<div class="dc-modal small bnt-modal">
  <div class="dc-modal__header">
    <h2 class="dc-modal__title">Blokiraj broj</h2>
    <span class="dc-modal__close" (click)="close()"></span>
  </div>
  <div class="dc-modal__body">
    <div class="dc-row">
      <div class="dc-col">
        <dc-input label="Broj telefona" [errorMessages]="{'required': 'Obavezno polje', 'phone_format': 'Pogrešan format broja telefona'}" [(ngModel)]="phoneNumber" [inputMask]="true"></dc-input>
      </div>
    </div>
  </div>
  <div class="dc-modal__actions">
    <div class="dc-modal__action-left">
    </div>
    <div class="dc-modal__action-right">
      <dc-button color="outline" (click)="close()">Odustani</dc-button>
      <dc-button [disabled]="!phoneNumber || phoneNumber.includes('_')" (click)="save()">Dodaj</dc-button>
    </div>
  </div>
</div>
